import { render, staticRenderFns } from "./BtsForm.vue?vue&type=template&id=1515efb7&"
import script from "./BtsForm.vue?vue&type=script&lang=js&"
export * from "./BtsForm.vue?vue&type=script&lang=js&"
import style0 from "./BtsForm.vue?vue&type=style&index=0&id=1515efb7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports